import {BaseContainerModel} from '../base-container.model';
import { bl_fi_mst_branch_intercompany_setting_RowInterface, bl_fi_mst_branch_intercompany_setting_RowClass } from '../../dbschema/bl_fi_mst_branch_intercompany_setting.model';

export class BranchIntercompanySettingContainerModel extends BaseContainerModel{
    bl_fi_mst_branch_intercompany_setting: bl_fi_mst_branch_intercompany_setting_RowInterface = new bl_fi_mst_branch_intercompany_setting_RowClass();   
}
